import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Subject, BehaviorSubject, merge } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { takeUntil, tap } from 'rxjs/operators';
import { MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
var ComplaintListComponent = /** @class */ (function () {
    function ComplaintListComponent(_complaintService, _matDialog, _matSnackBar, _translate, _translationLoader, _companyService) {
        this._complaintService = _complaintService;
        this._matDialog = _matDialog;
        this._matSnackBar = _matSnackBar;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this._companyService = _companyService;
        this.displayedColumns = ['complaint', 'complaint_category_name', 'created_at'];
        this.totalPages = 2;
        this.totalElements = 0;
        this.sortField = 'created_at';
        this.sordOrder = 'desc';
        this.pageSize = 10;
        this.lang = 'sr';
        this.company = { id: null, name: null, chat_token: null };
        this._unsubscribeAll = new Subject();
    }
    ComplaintListComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '23');
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    ComplaintListComponent.prototype.loadComplaintsPage = function () {
        this.dataSource.loadComplaints(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active || 'created_at', this.sort.direction || 'desc', '', this.company.id);
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    ComplaintListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var firstRun = true;
        this.dataSource = new FilesDataSource(this._complaintService);
        if (!this._companyService.activeCompany) {
            this._companyService.getActiveCompany()
                .then(function (response) {
                _this.company = response;
            })
                .catch(function (err) { return Promise.reject(err); })
                .then(function () {
                _this.loadComplaintsPage();
            }, function (err) {
            });
        }
        else {
            this.company = this._companyService.activeCompany;
            this.loadComplaintsPage();
        }
        this._complaintService.onComplaintsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this.totalPages = Math.floor(response.total / _this.paginator.pageSize) + 1;
            _this.totalElements = response.total;
            if (firstRun) {
                firstRun = false;
            }
            else {
                _this.dataSource.setData(response.data);
            }
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            console.log(_this._companyService.activeCompany);
            if (_this.company.id !== _this._companyService.activeCompany.id ? _this._companyService.activeCompany.id : response.id) {
                _this.company = _this._companyService.activeCompany;
                _this.loadComplaintsPage();
            }
        });
        this.getTranslations();
    };
    ComplaintListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // reset the paginator after sorting
        this.sort.sortChange.subscribe(function () { return _this.paginator.pageIndex = 0; });
        // on sort or paginate events, load a new page
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(tap(function () { return _this.loadComplaintsPage(); }))
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    };
    ComplaintListComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return ComplaintListComponent;
}());
export { ComplaintListComponent };
// Custom Angular CDK Data Source
var FilesDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(FilesDataSource, _super);
    /**
     * Constructor
     *
     * @param {ComplaintService} _complaintService
     */
    function FilesDataSource(_complaintService) {
        var _this = _super.call(this) || this;
        _this._complaintService = _complaintService;
        _this.complaintsSubject = new BehaviorSubject([]);
        _this.loadingSubject = new BehaviorSubject(false);
        _this.loading$ = _this.loadingSubject.asObservable();
        return _this;
    }
    FilesDataSource.prototype.connect = function () {
        return this.complaintsSubject.asObservable();
    };
    FilesDataSource.prototype.disconnect = function () {
        this.complaintsSubject.complete();
        this.loadingSubject.complete();
    };
    FilesDataSource.prototype.setData = function (data) {
        this.complaintsSubject.next(data);
        this.loadingSubject.next(false);
    };
    FilesDataSource.prototype.loadComplaints = function (page, limit, orderBy, order, search, company) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 20; }
        if (orderBy === void 0) { orderBy = 'created_at'; }
        if (order === void 0) { order = 'desc'; }
        if (search === void 0) { search = ''; }
        if (company === void 0) { company = 1; }
        this.loadingSubject.next(true);
        this._complaintService.listSubmittedComplaints(company, page, limit, orderBy, order, search).then(function (response) {
            console.log('loadComplaints.');
            _this.complaintsSubject.next(response.data);
            _this.loadingSubject.next(false);
        });
    };
    return FilesDataSource;
}(DataSource));
export { FilesDataSource };
